import styled from "styled-components";

const Form = styled.form`
  display: flex;
  flex-direction: column;
  padding: 14px;
  max-width: 400px;
`;

export default Form;
